var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgChatLine = function SvgChatLine(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.00004 8H4.66671V6.66667H6.00004V8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.66671 8H7.33337V6.66667H8.66671V8Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3334 8H10V6.66667H11.3334V8Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.33337 2C10.7479 2 12.1047 2.56166 13.1049 3.56185C14.1051 4.56204 14.6667 5.91885 14.6667 7.33333C14.6667 8.74782 14.1051 10.1046 13.1049 11.1048C12.1047 12.105 10.7479 12.6667 9.33337 12.6667V15C6.00004 13.6667 1.33337 11.6667 1.33337 7.33333C1.33337 5.91885 1.89503 4.56204 2.89522 3.56185C3.89542 2.56165 5.25222 2 6.66671 2H9.33337ZM6.66671 3.33333C5.60584 3.33333 4.58873 3.75506 3.83858 4.50521C3.08844 5.25535 2.66671 6.27247 2.66671 7.33333C2.66671 9.74 4.30804 11.311 8.00004 12.987V11.3333H9.33337C9.85865 11.3333 10.3787 11.2297 10.864 11.0286C11.3493 10.8276 11.7901 10.5329 12.1615 10.1615C12.5329 9.79002 12.8277 9.34924 13.0287 8.86393C13.2297 8.37864 13.3334 7.85861 13.3334 7.33333C13.3334 6.80806 13.2297 6.28802 13.0287 5.80273C12.8277 5.31743 12.5329 4.87664 12.1615 4.50521C11.7901 4.13377 11.3493 3.83904 10.864 3.63802C10.3787 3.43701 9.85865 3.33333 9.33337 3.33333H6.66671Z",
    fill: "currentColor"
  })));
};
export default SvgChatLine;